var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.checked)?_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.toggleTricker.apply(null, arguments)}}},[_c('span',{staticClass:"fas fa-sign-in-alt"}),_vm._v(" REGISTER/LOGIN")]):_c('a',{attrs:{"href":_vm.accountUrl}},[_c('span',{staticClass:"fas fa-user"}),_vm._v(" MY ACCOUNT")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb280c34","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Soundrink/soundrink-auth-trigger.vue
// module id = Upaa
// module chunks = 116